import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { CommentListAction, initialState } from "./initialState";
import { getProductComment } from "@/src/models/review_es";

export const useCommentListStore = create<CommentListAction>()(
    devtools(
        persist(
            (set, get) => ({
                ...initialState,
                getCommentPhotoList: async (
                    id: number,
                    data: Record<string, any>,
                    visitor_id?: string,
                ) => {
                    const DATA = {
                        type: 1,
                        filter: "picture",
                        zan: true,
                        ...data,
                    };
                    const result = await getProductComment(
                        id,
                        DATA,
                        visitor_id,
                    );
                    set({
                        isLoading: false,
                        commentList: result.data,
                        pagination: result.pagination,
                    });
                },
            }),
            {
                name: "comment-list-storage",
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {
            name: "comment-list-store",
        },
    ),
);
